import { AdminConfiguration } from '@centecomm/admin-config-service';
import { UserPermissions } from '@centecomm/portal-service';
import { NounIconChat, NounIconInvoice, NounNewRequest, NounNews } from '../../../Icons';
import { DashboardLink } from '../Types/DashboardLink';

const getOOLinks = (
    hasPermission: (permission: UserPermissions) => boolean,
    settings: AdminConfiguration | undefined,
    complianceHubEnabled: boolean = false,
): DashboardLink[] => {
    const linksForUser: DashboardLink[] = [];

    if (settings?.request?.visible && (settings?.landingPage?.createRequestOwnerOperator ?? true)) {
        linksForUser.push({
            text: 'Create a Request',
            url: '/requests/create',
            Icon: NounIconChat,
        });
    }

    if (settings?.communication?.visible && (settings?.landingPage?.viewNewsOwnerOperator ?? true)) {
        linksForUser.push({
            text: 'View All News',
            url: '/communications/news',
            Icon: NounNews,
        });
    }

    if (settings?.request?.visible && (settings?.landingPage?.viewRequestOwnerOperator ?? true)) {
        linksForUser.push({
            text: 'View New Requests',
            url: '/requests/new',
            Icon: NounNewRequest,
        });
    }

    if (
        hasPermission(UserPermissions.ViewCertificateOfInsurance) &&
        settings?.insurance?.visible &&
        (settings?.landingPage?.viewInsuranceOwnerOperator ?? true)
    ) {
        linksForUser.push({
            text: 'View Insurance',
            url: '/insurance',
            Icon: NounIconInvoice,
        });
    }

    return linksForUser;
};

export default getOOLinks;
